<fcom-modal
  data-testid="cancel-flights-confirm-modal"
  [(open)]="isOpen"
  [title]="(eligibility.isAllowedToUse ? 'MMB.cancelBooking.modalTitleQuestion' : 'MMB.cancelBooking.modalTitle') | finLocalization"
  [fitToContent]="true"
  [fullHeight]="true"
  [buttons]="ModalButtons.CUSTOM"
  (close)="closeModal()"
>
  <div class="pr-large">
    <ng-container *ngIf="eligibility.isAllowedToUse else notEligible">
      <cms-unstyled-fragment
        *ngIf="hasCoverServicePurchased else notCoverServicePurchased"
        data-testid="checkin-cancel-cacr"
        [showTitle]="false"
        [contentUrl$]="'MMB.fragments.cancelBookingModalConfirmWithCACR.url' | finLocalization | finToObservable"
      >
      </cms-unstyled-fragment>

      <ng-template #notCoverServicePurchased>
        <cms-unstyled-fragment
          data-testid="checkin-cancel-eligible"
          [showTitle]="false"
          [contentUrl$]="'MMB.fragments.cancelBookingModalConfirm.url' | finLocalization | finToObservable"
        >
        </cms-unstyled-fragment>
      </ng-template>
    </ng-container>

    <ng-template #notEligible>
      <div class="font-body-1" data-testid="checkin-cancel-ineligibility">
        {{'MMB.cancelBooking.inEligibilities.' + eligibility.reason | finLocalization}}
      </div>
    </ng-template>
  </div>

  <div buttons>
    <fcom-button
      data-testid="cancel-flights-confirm-modal-close-button"
      [text]="'actions.close' | finLocalization"
      (clickBtn)="closeModal(false)"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [aria]="{ label: 'actions.close' | finLocalization, role: 'button' }"
      class="mr-xsmall-r"
    ></fcom-button>
    <fcom-button
      data-testid="cancel-flights-confirm-modal-continue-button"
      *ngIf="eligibility.isAllowedToUse"
      [text]="'MMB.cancelBooking.continueToCancel' | finLocalization"
      (clickBtn)="navigateToCancelFlow()"
      [aria]="{ label: 'MMB.cancelBooking.continueToCancel' | finLocalization, role: 'button' }"
    ></fcom-button>
  </div>
</fcom-modal>
